import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  id: "quiz-viewer-layout-timer-block",
  class: "timer-block"
};
const _hoisted_2 = {
  class: "content-block"
};
const _hoisted_3 = {
  key: 1,
  id: "quiz-viewer-layout-footer-block",
  class: "footer-block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: "quiz-viewer-layout",
    class: _normalizeClass(['quiz-viewer-layout', {
      center: _ctx.centerContent
    }])
  }, [_ctx.timerExists() ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "timer", {}, undefined, true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "content", {}, undefined, true)]), _ctx.footerExists() ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "footer", {}, undefined, true)])) : _createCommentVNode("", true)], 2);
}